// extracted by mini-css-extract-plugin
var _1 = "eSFTZVFepm";
var _2 = "_EcjMkD1Yz";
var _3 = "CdF8BmiJze";
var _4 = "vSHjzdajKF";
var _5 = "A4_DIhBuVP";
export { _1 as "textCenter", _2 as "textEnd", _3 as "textNoWrap", _4 as "textStart", _5 as "textTruncate" }
